import React from "react";

const StringsContext = React.createContext({});

export default StringsContext;